import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const AccountTransitionInfoRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>AccountTransitionInfoRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid => navigate(atlasRoutes.accountsView({ params: { accountId: uuid } }).path)}
      />
    </div>
  );
};
